module.exports = __webpack_public_path__ + "static/communications-e0c08bb001990f78d76a6a5809d7b381.png";